<template>
  <div class="width98 margin-auto f14 margin-top10">
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <!-- 检索 -->

        <div class="Retrieveform pad-top20 pad-bot10 lineheight40">
          <div class="flex-betweennowrap width96 margin-auto">
            <p class="Patent-abstract pad-left10 dimensional">基本信息</p>
            <div>
              <span
                class="cursorpointer attention"
                @click="addteadmarkfollow()"
              >
                加入瞭望台
              </span>
              <span
                class="cursorpointer attention margin-left10"
                @click="addteadmarksearch()"
              >
                商标检索
              </span>
              <span
                class="cursorpointer attention margin-left10"
                @click="addpantensearch()"
              >
                专利检索
              </span>
            </div>
          </div>
          <div class="width96 margin-auto pad-top20 pad-bot20">
            <table class="width100 text-ellipsis">
              <tr>
                <td class="tdtit">企业名称</td>
                <td class="tdcont">{{ company }}</td>
                <td class="tdtit">法人代表</td>
                <td class="tdcont">{{ legal_representative }}</td>
              </tr>
              <tr>
                <td class="tdtit">信用代码</td>
                <td class="tdcont">{{ cert_id }}</td>
                <td class="tdtit">注册资本</td>
                <td class="tdcont">{{ capital }}元</td>
              </tr>
              <tr>
                <td class="tdtit">成立时间</td>
                <td class="tdcont">{{ register_date }}</td>
                <td class="tdtit">网址</td>
                <td class="tdcont">{{ website }}</td>
              </tr>
            </table>
            <table class="width100 text-ellipsis">
              <tr>
                <td class="tdtit" style="border-top: none">注册地址</td>
                <td class="tdconts" style="border-top: none">{{ address }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div
          class="Retrieveform pad-top20 pad-bot10 lineheight30 f14 margin-top10"
        >
          <div class="width96 margin-auto">
            <p class="Patent-abstract pad-left10 dimensional">经营范围</p>
            <p class="f14 pad-top20 pad-bot20">
              {{ scope }}
            </p>
          </div>
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { entdetail, ADDmonitordetail } from "@/api/patent/patent.api";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      companykey: "",
      company: "",
      legal_representative: "",
      cert_id: "",
      capital: "",
      register_date: "",
      scope: "",
      website: "",
      address: "",
    };
  },
  methods: {
    // 加入关注
    addteadmarkfollow() {
      ADDmonitordetail({ company_name: this.company }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "已加入关注",
            type: "success",
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 专利检索、
    addpantensearch() {
      window.sessionStorage.setItem("patenteep", this.company);
      this.$router.push({ path: "/Data-Homepage/Patent-search" });
    },
    // 商标检索
    addteadmarksearch() {
      window.sessionStorage.setItem("register", this.company);
      this.$router.push({ path: "/Data-Homepage/Trademark-search" });
    },
  },
  created() {
    // 获取企业详情
    this.companykey = window.sessionStorage.getItem("company_key");
    entdetail({ client_key: this.companykey }).then((res) => {
      if (res.data.code == 200) {
        this.cont = res.data.data;
        this.company = this.cont.company;
        this.legal_representative = this.cont.legal_representative;
        this.cert_id = this.cont.cert_id;
        this.capital = this.cont.capital;
        this.register_date = this.cont.register_date;
        this.scope = this.cont.scope;
        this.website = this.cont.website;
        this.address = this.cont.address;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.Retrieveform {
  background: #fff;
  border-radius: 3px;
}
.pagination {
  border-bottom: 1px solid #cacaca;
}
.Patent-abstract {
  border-left: 4px solid #52c5cb;
  height: 20px;
  line-height: 20px;
}
.icon {
  font-size: 12px;
}
table {
  border-collapse: collapse;
}
tr {
  width: 100%;
}
td {
  border: 1px solid #f0f0f0;
}
.tdtit {
  width: 15%;
  height: 40px;
  background: #f1f3f9;
  border: 1px solid rgba(233, 233, 233, 1);
  padding-left: 10px;
  font-size: 14px;
  color: #6a7589;
}
.tdcont {
  width: 35%;
  padding-left: 10px;
  height: 40px;
  font-size: 14px;
  color: #353a44;
}
.tdcontss {
  width: 15%;
  padding-left: 10px;
  height: 40px;
  font-size: 14px;
  color: #353a44;
  border: 1px solid rgba(233, 233, 233, 1);
  border-top: none;
}
.tdconts {
  width: 85%;
  padding-left: 10px;
  height: 40px;
  font-size: 14px;
  color: #353a44;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>